<template>
  <div>
    <vm-table
        ref="vmTable"
        height="65vh"
        :filter.sync="filter"
        module="basic"
        url="products"
        @select="selectTest">
      <el-button
          v-if="addAuth"
          slot="toolbar"
          type="primary"
          size="mini"
          @click="$refs.editPage.open(0)">
        新增
      </el-button>
      <template slot="adSearch">
        <div class="vm-search">
          <vm-search label="关键词">
            <el-input v-model.trim="filter.filter" clearable/>
          </vm-search>
        </div>
      </template>
      <el-table-column prop="name" label="名称"/>
      <el-table-column prop="model" label="型号"/>
      <el-table-column prop="categoryName" label="产品类别"/>
      <!--      <el-table-column prop="PicturePath" label="图片">
        <template slot-scope="scope">
          <img v-if="scope.row.PicturePath.length > 0" :src="scope.row.PicturePath">
          <span v-else>无</span>
        </template>
      </el-table-column>-->
      <el-table-column prop="createTime" label="创建时间">
        <template slot-scope="scope">
          {{scope.row.createTime}}
        </template>
      </el-table-column>
      <el-table-column prop="lastUpdateTime" label="最近更新">
        <template slot-scope="scope">
          {{scope.row.lastUpdateTime}}
        </template>
      </el-table-column>
      <el-table-column
          label="操作"
          align="center"
          class-name="vm-table_operate"
          width="180px">
        <template slot-scope="scope">
          <el-button style="background: #f4f7fa">
            <router-link :to="'/productPreview/'+scope.row.id" target="_blank">预览</router-link>
          </el-button>
          <el-button type="primary" @click="$refs.editPage.open(scope.row.id)">编辑</el-button>
          <el-button type="danger" @click="deleteRow(scope.row)">删除</el-button>
        </template>
      </el-table-column>
    </vm-table>
    <product-edit ref="editPage" @save-success="getList(-1)"/>
  </div>
</template>
<script>
  import VmTable from "@/components/VmTable.vue";
  import VmSearch from "@/components/VmSearch.vue";
  import ProductEdit from "@/views/information/Product/ProductEdit";
  export default {
    name: "Product",
    components: {ProductEdit, VmTable, VmSearch},
    data() {
      return {
        addAuth: this.$auth(633),
        editAuth: this.$auth(635),
        deleteAuth: this.$auth(634),
        idList: "",
        filter: {
          filter: "",
        },
      };
    },
    mounted() {
      this.getList(1);
    },
    methods: {
      getList(pageNum) {
        this.$refs.vmTable.getList(pageNum);
      },
      selectTest(selection) {
        this.idList = selection;
      },
      deleteRow(row) {
        this.$confirm("确定删除吗?", "提示", {type: "warning"}).then(() => {
          this.$http.delete("basic","/products", row.id).then(() => {
            this.getList(-1);
            this.$message.success("删除成功");
          });
        });
      },
    },
  };
</script>
<style lang="scss" scoped>
</style>
